import router from '@/router';
// import { Upload } from 'element-ui';
import format from 'date-fns/format';

/**
 * 券种分类
 */
const CATEGORY_DICT: any = {
  DISCOUNT: ['折扣券', 0],
  GIFT: ['礼品券', 1],
  CASH: ['代金券', 2],
  FREE: ['免费试吃试用', 6],
  SINGLE: ['单品优惠', 7],
  BRAND: ['品牌活动', 8],
  STANDARD: ['通用券', 9],
  PARKING: ['停车券', 10],
  COM_REDPACK: ['企业付款红包', 11],
  PRECASH: ['预充值代金劵', 12],
  REDUCTION: ['立减券', 13],
};
const couponCategoryList: any = [
  { categoryId: '0', categoryName: '折扣券' },
  { categoryId: '1', categoryName: '礼品券' },
  { categoryId: '2', categoryName: '代金券' },
  // { categoryId: '6', categoryName: '免费试吃试用' },
  // { categoryId: '7', categoryName: '单品优惠' },
  // { categoryId: '8', categoryName: '品牌活动' },
  { categoryId: '9', categoryName: '通用券' },
  // { categoryId: '10', categoryName: '停车券' },
  // { categoryId: '11', categoryName: '企业付款红包' },
  // { categoryId: '12', categoryName: '预充值代金劵' },
  { categoryId: '13', categoryName: '立减券' },
]
const couponCategoryObj: any = {
  '0': '折扣券',
  '1': '礼品券',
  '2': '代金券',
  // '6': '免费试吃试用',
  // '7': '单品优惠',
  // '8': '品牌活动',
  '9': '通用券',
  // '10': '停车券',
  // '11': '企业付款红包',
  // '12': '预充值代金劵',
  '13': '立减券',
}

/**
 * 券种有效期
 */
const VALIDATE_TYPE_DICT: any = {
  DISPLAY: ['展示有效期', 'display'],
  GET: ['领取有效期', 'get'],
  VERIFY: ['核销有效期', 'verify'],
};

/**
 * 券种状态
 */
const STATUS_DICT: any = {
  CREATED: ['已创建', 10],
  WAIT: ['待审核', 20],
  LAUNCHED: ['已投放', 30],
  NOT_ENOUGH: ['已领光', 40],
  STOPPED: ['已禁用', 50],
  FINISHED: ['已结束', 60],
};

/**
 * 券实体状态
 */
const STATUS_ENTITY_DICT: any = {
  GET: ['已领取', 2],
  EFFECTIVE: ['已核销', 3],
  INVALID: ['已过期', 4],
};

/**
 * 券实体列表中的关键字类型筛选条件;
 */
const FILTER_KEYWORD_TYPE_DICT: any = {
  COUPON_NAME: ['券名称', 0],
  COUPON_QRCODE: ['券码', 1],
  COUPON_EXTEND_INFO: ['主标题', 2],
  MOBILE: ['手机号', 3],
  OPENID: ['openid', 4],
  EFFECTIVE_ENTITY: ['核销主体', 5],
  EFFECTIVE_PEOPLE: ['核销人', 6],
};

/**
 * 券实体列表中的时间筛选条件
 */
const FILTER_DATE_TYPE_DICT: any = {
  GET: ['领取时间', 0],
  EFFECTIVE: ['核销时间', 1],
};

let debouce: number = 0;

const COUPON_NO_PIC_URL = 'https://wxapp.beijingapm.top/sences/images/20190918/1568790527489.png';

export default {
  state:
  {
    categoryList: [],
    BuildingList: [],
    list: [],
    couponList: [],
    activityList: [],
    couponCancelList: [], /** 核销记录 */
    couponCancelPage: {
      total: 0,
      pageNum: 0,
      pageSize: 10,
    }, /**数量，页码信息 */
    couponCancelPageLoading: false,
    couponCategoryList,
    couponSearchStep: 0,
    analysisGetTotal: 0,
    analysisGetFree: 0,
    analysisGetCharge: 0,
    analysisEffectiveTotal: 0,
    analysisEffectiveFree: 0,
    analysisEffectiveCharge: 0,
    infoSearchName: '',
    infoId: '',
    infoName: '',
    infoStatus: '',
    infoStatusDesc: '',
    infoMainInfo: '',
    infoExtendInfo: '',
    infoUnitPrice: 0,
    couponDescClause: '',
    infoCost: 0,
    infoCategoryId: '',
    infoCategoryIdDesc: '',
    infoActivityId: '',
    infoActivityName: '',
    infoQuantity: 0,
    infoGetQuantity: 0,
    infoEffectiveQuantity: 0,
    infoDisplayDate: '',
    infoGetDate: '',
    infoGetWeeks: '',
    infoGetTimes: '',
    infoEffectiveDate: '',
    infoEffectiveWeeks: '',
    infoEffectiveTimes: '',
    infoEffectiveEntityType: '',
    infoEffectiveEntityList: [],
    putInShop: '', // 投放店铺
    infoTenantName: '',
    infoDesc: '',
    infoPics: [],
    infoHtml: [],
    infoEffectiveConditionLimit: '',
    infoDayLimit: '',
    infoTotalLimit: '',
    infoWarningLimit: '',
    infoEffectiveCategoryIdLimit: '',
    infoPrecouponSwitch: 0,
    infoExternalCodeList: [],
    effectiveQrCode: '',
    effectiveSessionId: '',
    businessEntityGroupList: [], // 店铺组
    effectiveCouponEntity: {},
  },
  getters:
  {
    CATEGORY(state: any) {
      return router.app.$parseDict(CATEGORY_DICT, -1).filter((item: any) => {
        return state.categoryList.find((cat: any) => cat.categoryId == item.value);
      });
    },
    CATEGORY_NAME(state: any) {
      return router.app.$parseDict(CATEGORY_DICT);
    },
    CATEGORY_VALUE(state: any) {
      return router.app.$parseDict(CATEGORY_DICT, 1);
    },
    VALIDATE_TYPE(state: any) {
      return router.app.$parseDict(VALIDATE_TYPE_DICT, -1);
    },
    VALIDATE_TYPE_VALUE(state: any) {
      return router.app.$parseDict(VALIDATE_TYPE_DICT, 1);
    },
    STATUS(state: any) {
      return router.app.$parseDict(STATUS_DICT, -1);
    },
    STATUS_VALUE(state: any) {
      return router.app.$parseDict(STATUS_DICT, 1);
    },
    FILTER_KEYWORD_TYPE(state: any) {
      return router.app.$parseDict(FILTER_KEYWORD_TYPE_DICT, -1);
      return Object.entries(FILTER_KEYWORD_TYPE_DICT).map((item: Array<any>) => {
        return { label: item[1][0], value: item[1][1] };
      });
    },
    FILTER_KEYWORD_TYPE_VALUE(state: any) {
      return router.app.$parseDict(FILTER_KEYWORD_TYPE_DICT, 1);
    },
    FILTER_DATE_TYPE(state: any) {
      return router.app.$parseDict(FILTER_DATE_TYPE_DICT, -1);
    },
    FILTER_DATE_TYPE_VALUE(state: any) {
      return router.app.$parseDict(FILTER_DATE_TYPE_DICT, 1);
    },
    FILTER_STATUS_ENTITY_TYPE(state: any) {
      return router.app.$parseDict(STATUS_ENTITY_DICT, -1);
    },
    FILTER_STATUS_ENTITY_TYPE_VALUE(state: any) {
      return router.app.$parseDict(STATUS_ENTITY_DICT, 1);
    },
    infoEffectiveEntityListWithSearch(state: any) {
      return state.infoEffectiveEntityList
        .filter((item: any) =>
          new RegExp(state.infoSearchName, 'gi').test(item.couponEntityBusinessEntityName),
        )
        .map((item: any) => {
          if (/\S/g.test(state.infoSearchName)) {
            item.couponEntityBusinessEntityName = String(item.couponEntityBusinessEntityName).replace(
              new RegExp('(' + state.infoSearchName + ')', 'gi'),
              '<span style="background: yellow;">$&</span>',
            );
          }
          return item;
        });
    },
    infoEffectiveEntityList(state: any, getters: any) {
      let arr: Array<any> = [];
      let EntityList: Array<any> = getters.infoEffectiveEntityListWithSearch;
      for (let i = EntityList.length - 1; i >= 0; i--) {
        let entity = EntityList[i];
        let arrChild = arr.find(item => item.floorId == entity.floorId);
        if (!arrChild) {
          arr.push({
            floorId: entity.floorId,
            floorName: entity.floorName,
            children: [],
          });
          arrChild = arr[arr.length - 1];
        }
        arrChild.children.push({
          couponEntityBusinessEntityId: entity.couponEntityBusinessEntityId,
          couponEntityBusinessEntityName: entity.couponEntityBusinessEntityName,
        });
      }
      return arr;
    },
  },
  mutations:
  {
    setActivityList(state: any, { list, total }: any) {
      state.activityList = [...state.activityList, ...(list || [])];
    },
    resetActivityList(state: any) {
      state.activityList = []
    },
    setCategoryList(state: any, list: Array<any>) {
      state.categoryList = [...list];
    },
    setBuildingList(state: any, list: Array<any>) {
      state.BuildingList = [...list];
    },
    setCouponList(state: any, { list, total }: any) {
      state.list = [...list, { total }];
      state.couponList = [...state.couponList, ...list];
    },
    resetCouponList(state: any) {
      state.couponList = []
    },
    setCouponCancelListActive(state: any, { item, index }: any) {
      state.couponCancelList[index].couponPutinActived = !item.couponPutinActived;
    },
    setcouponSearchStep(state: any, num: any) {
      state.couponSearchStep = num;
    },
    setCouponCancelList(state: any, { list, total, pageNum, pageSize, status }: any) {
      const _list = list.map((item: any) => {
        let _item = item;
        _item.couponInstanceWriteOffTime = router.app.$format(_item.couponInstanceWriteOffTime);
        _item.couponInstanceGetTime = router.app.$format(_item.couponInstanceGetTime);
        _item.couponEffectiveStartTime = router.app.$format(_item.couponEffectiveStartTime);
        _item.couponEffectiveEndTime = router.app.$format(_item.couponEffectiveEndTime);
        _item.imgurl = _item.photoUriList ? _item.photoUriList[0] : 'COUPON_NO_PIC_URL';
        _item.couponPutinActived = false;
        _item.couponCategoryName = couponCategoryObj[_item.couponCategoryId + ''];
        return _item
      });
      if (status) {
        state.couponCancelList = _list
      } else {
        state.couponCancelList = [...state.couponCancelList, ..._list];
      }
      state.couponCancelPage = {
        total,
        pageNum,
        pageSize,
      }; /**数量，页码信息 */
    },
    setcancelPage(state: any, pageNum: number) {
      state.couponCancelPage = {
        total: 0,
        pageNum: 0,
        pageSize: 10,
      }; /**数量，页码信息 */
    },
    setCouponCancelPageLoading(state: any, status: boolean) {
      if (status) {
        state.couponCancelPageLoading = true;
      } else {
        state.couponCancelPageLoading = false;
      }
    },
    setCouponAnalysis(state: any, data: any) {
      state.analysisGetTotal = data.receivedCouponNum;
      state.analysisGetFree = data.receivedCouponNumFree;
      state.analysisGetCharge = data.receivedCouponNumUnFree;
      state.analysisEffectiveTotal = data.writeOffCouponNum;
      state.analysisEffectiveFree = data.writeOffCouponNumFree;
      state.analysisEffectiveCharge = data.writeOffCouponNumUnFree;
    },
    setCouponId(state: any, id: number) {
      state.infoId = id;
    },
    setCouponInfo(state: any, data: any) {
      state.infoId = data.couponId;
      state.infoName = data.couponName;
      state.infoStatus = data.couponStatus;
      state.infoStatusDesc = data.couponStatusDesc;
      state.infoMainInfo = data.couponMainInfo;
      state.infoExtendInfo = data.couponExtendInfo;
      state.infoUnitPrice = Number(data.couponUnitPrice).d(100);
      state.couponDescClause = data.couponDescClause;
      state.infoCost = Number(data.couponCost).d(100);
      state.infoCategoryId = data.couponCategoryId;
      state.infoCategoryIdDesc = data.couponCategoryIdDesc;
      state.infoActivityId = data.couponActivityId;
      state.infoActivityName = data.couponActivityName;
      state.putInShop = data.couponIsReplace ? data.couponOperateBusinessEntityName : data.couponBusinessEntityName
      state.infoQuantity = (router.app as any).$thousand(data.couponQuantity);
      state.infoGetQuantity = (router.app as any).$thousand(data.getQuantity);
      state.infoEffectiveQuantity = (router.app as any).$thousand(data.effectiveQuantity);
      state.infoDisplayDate =
        data.couponDisplayTimeSwitch == 0
          ? '不限日期'
          : [data.couponDisplayStartTime.replace(/-/g, '.'), data.couponDisplayEndTime.replace(/-/g, '.')].join('-');
      state.infoGetDate = [(data.couponGetStartTime || '').replace(/-/g, '.'), (data.couponGetEndTime || '').replace(/-/g, '.')].join('-');
      state.infoGetWeeks =
        data.couponGetTimeLimitSwitch == 0
          ? '不限星期'
          : (data.getTimeLimitWeekList || [])
            .map((item: number) => {
              return ['周一', '周二', '周三', '周四', '周五', '周六', '周日'][item - 1];
            })
            .join(',');
      state.infoGetTimes =
        data.couponGetTimeLimitSwitch == 0
          ? '不限时段'
          : (data.getTimeLimitTimeList || [])
            .map((item: any) => item.startTime + '-' + item.endTime)
            .join(',');
      state.infoEffectiveDate = [
        [(data.couponEffectiveStartTime || '').replace(/-/g, '.'), (data.couponEffectiveEndTime || '').replace(/-/g, '.')].join('-'),
        data.couponActivedLimitedStartDay == 0 && data.couponActivedLimitedDays == 1
          ? '仅当天有效'
          : (data.couponActivedLimitedStartDay == 0
            ? '领取后当天开始(含当天)有效'
            : '领取后' +
            (data.couponActivedLimitedStartDay + 1 > 0
              ? '第' + (data.couponActivedLimitedStartDay + 1) + '天开始(含当天)有效'
              : '当天开始有效')) +
          ', 有效期' +
          data.couponActivedLimitedDays +
          '天',
        [data.couponGetStartTime, data.couponGetEndTime].join('至'),
      ][data.couponEffectiveSwitch];
      state.infoEffectiveWeeks =
        data.couponEffectiveTimeLimitSwitch == 0
          ? '不限星期'
          : (data.effectiveTimeLimitWeekList || [])
            .map((item: number) => {
              return ['周一', '周二', '周三', '周四', '周五', '周六', '周日'][item - 1];
            })
            .join(',');
      state.infoEffectiveTimes =
        data.couponEffectiveTimeLimitSwitch == 0
          ? '不限时段'
          : (data.effectiveTimeLimitTimeList || [])
            .map((item: any) => item.startTime + '-' + item.endTime)
            .join(',');
      state.infoEffectiveEntityType = ['全部商户', '共' + (data.couponEntityList || []).length + '家商户', '仅限本商户'][
        data.couponEffectiveEntityLimitType - 1
      ];
      state.infoEffectiveEntityList = [[], data.couponEntityList || [], []][
        data.couponEffectiveEntityLimitType - 1
      ];
      state.infoTenantName = data.couponBusinessEntityName;
      state.infoDesc = data.couponDescClause.replace(/(\r|\n)/g, '<br>');
      state.infoPics = data.photoUriList || [];
      state.infoHtml = router.app.$flatten(
        (data.imageInfoVoList || []).map((item: any) => {
          let img = item.img || item.pic || item.src;
          let html = item.html;
          return [img ? "<img src='" + img + "' style='width: 100%;'/>" : '', html || ''].filter(
            item => !!item,
          );
        }),
      );
      state.infoEffectiveConditionLimit = [
        '不限金额',
        '消费满' +
        (router.app as any).$currency(Number(data.couponEffectiveConditionPrice).d(100)) +
        '元, 可使用此券',
      ][data.couponEffectiveConditionSwitch];
      state.infoDayLimit = ['不限数量', (router.app as any).$thousand(data.couponDayLimitNum) + '张'][
        data.couponDayLimitNumSwitch
      ];
      state.infoTotalLimit = ['不限数量', (router.app as any).$thousand(data.couponCumulativeLimitNum) + '张'][
        data.couponCumulativeLimitNumSwitch
      ];
      state.infoWarningLimit = [
        '无预警',
        '低于' + (router.app as any).$thousand(data.couponMarginWarningQuantity) + '张',
      ][data.couponMarginWarningSwitch];
      state.infoEffectiveCategoryIdLimit = ['不限品类', data.couponEffectiveCategoryLimitName][
        data.couponEffectiveCategoryLimitSwitch
      ];
      state.infoPrecouponSwitch = data.couponPrecouponSwitch;
    },
    setCouponExternalCode(state: any, { list, total }: any) {
      state.infoExternalCodeList = [...(list || []), { total }];
    },
    setInfoSearchName(state: any, search: string) {
      clearInterval(debouce);
      debouce = setTimeout(() => {
        state.infoSearchName = search;
      }, 300);
    },
    setEffectiveQrCode(state: any, qrcode: string) {
      state.effectiveQrCode = qrcode;
    },
    setEffectiveSessionId(state: any, sessionId: string) {
      state.effectiveSessionId = sessionId;
    },
    businessEntityGroupList(state: any, list: Array<any>) {
      state.businessEntityGroupList = list;
    },
    setEffectiveCouponEntity(state: any, data: any) {
      state.effectiveCouponEntity = data;
    },
    clearCouponCancelList(state: any, data: any) {
      state.couponCancelList = [];
    },
    clearActivityList(state: any, data: any) {
      state.activityList = [];
    }
  },

  actions:
  {
    async getCategoryList({ commit }: any) {
      commit('setCategoryList', []);
      let params = {
        entityType: router.app.$global.tenantType,
        entityId: router.app.$global.tenantId,
      };
      const { error, success }: any = await router.app.$request('COUPON_CATEGORY_LIST', params);
      if (success) {
        commit('setCategoryList', success.data);
      }
      return { error, success };
    },
    async getBuildingList({ commit, state }: any) {
      if (state.BuildingList.length) {
        return { success: state.BuildingList };
      }

      commit('setBuildingList', []);
      const { error, success }: any = await router.app.$request('FLOOR_LIST', {
        businessEntityId: router.app.$global.tenantId,
        lbsBuildingId: ' ',
      });
      if (success) {
        let list = (success.data || []).map((item: any) => {
          return {
            id: item.lbsBuildingId,
            thirdPartyId: item.lbsBuildingThirdPartyId,
            entityId: item.businessEntityId,
            entityTypeId: item.businessEntityTypeId,
            name: item.lbsBuildingName,
            floorList:
              (item.floorList || []).map((item: any) => {
                return {
                  id: item.lbsFloorId,
                  buildingId: item.lbsBuildingThirdPartyId,
                  floorId: item.lbsFloorThirdPartyId,
                  name: item.lbsFloorName,
                  aliasName: item.lbsFloorAliasName,
                  desc: item.lbsFloorFunctionDesc,
                  shopList: [],
                };
              }),
          };
        });
        for (let building of list) {
          for (let floor of building.floorList) {
            const { error: err, success: suc }: any = await router.app.$request('SHOP_LIST', {
              lbsBuildingThirdPartyId: floor.buildingId,
              lbsFloorThirdPartyId: floor.floorId,
            });
            if (suc) {
              floor.shopList = (suc.data || []).map((item: any) => {
                return {
                  id: item.businessEntityId,
                  typeId: item.businessEntityTypeId,
                  name: item.businessEntityNameCn,
                  aliasName: item.businessEntityShowName,
                  floorId: floor.id,
                  floorName: floor.name,
                };
              });
            }
          }
        }
        commit('setBuildingList', list);
      }
      return { error, success: state.BuildingList };
    },
    async addCoupon({ commit }: any, params: any) {
      const formatTime = function (val: number) {
        const hours: number = Math.floor(val / 3600);
        const minutes: number = Math.floor((val % 3600) / 60);
        const seconds: number = Math.floor(val % 60);
        return [
          hours > 9 ? hours : '0' + hours,
          minutes > 9 ? minutes : '0' + minutes,
          seconds > 0 ? (seconds > 9 ? seconds : '0' + seconds) : '',
        ]
          .filter(item => !!item)
          .join(':');
      };

      params.couponFacePrice = Number(params.couponFacePrice).c(100);
      params.couponUnitPrice = Number(params.couponUnitPrice).c(100);
      params.couponCost = Number(params.couponCost).c(100);
      params.couponEffectiveConditionPrice = Number(params.couponEffectiveConditionPrice).c(100);
      params.couponDisplayStartTime = params.couponDisplayStartTime ? format(params.couponDisplayStartTime, 'YYYY-MM-DD') : '';//展示有效期
      params.couponDisplayEndTime = params.couponDisplayEndTime ? format(params.couponDisplayEndTime, 'YYYY-MM-DD') : ''; //展示有效期
      params.couponGetStartTime = params.couponGetStartTime ? format(params.couponGetStartTime, 'YYYY-MM-DD') : ''; //领取有效期
      params.couponGetEndTime = params.couponGetEndTime ? format(params.couponGetEndTime, 'YYYY-MM-DD') : ''; //领取有效期
      params.couponEffectiveStartTime = params.couponEffectiveStartTime ? format(params.couponEffectiveStartTime, 'YYYY-MM-DD') : ''; //核销有效开始日期
      params.couponEffectiveEndTime = params.couponEffectiveEndTime ? format(params.couponEffectiveEndTime, 'YYYY-MM-DD') : ''; //核销有效结束日期
      // params.imageInfoVoList = params.imageInfoVoList
      // 	.map((item: any) => {
      // 		if (!item.img && !item.html) return null;
      // 		return item.isIMG
      // 			? { img: item.img, html: '' }
      // 			: item.isHTML ? { img: '', html: (item.html || '').replace(/(\r|\n)/g, '<br>') } : null;
      // 	})
      // 	.filter((item: any) => !!item);
      // params.couponEntityList = params.couponEntityList.map((item: any) => {
      // 	return {
      // 		couponEntityBusinessEntityId: item.couponEntityBusinessEntityId || item.id,
      // 		couponEntityBusinessEntityName: item.couponEntityBusinessEntityName || item.name,
      // 		floorId: item.floorId || '',
      // 		floorName: item.floorName || '',
      // 	};
      // });
      params.photoUriList = params.photoUriList.map((item: any) => item.url)
      params.couponBusinessEntitySwitch = 0
      params.couponBusinessEntityId = router.app.$global.tenantId;
      params.couponBusinessEntityTypeId = router.app.$global.tenantType;
      params.couponBusinessEntityName = router.app.$global.tenantName;

      params.couponOperateBusinessEntityId = router.app.$global.tenantId;
      params.couponOperateBusinessEntityTypeId = router.app.$global.tenantType;
      params.couponOperateBusinessEntityName = router.app.$global.tenantName;

      params.couponDayLimitNum = Number(params.couponDayLimitNum);
      params.couponCumulativeLimitNum = Number(params.couponCumulativeLimitNum);
      params.couponMarginWarningQuantity = Number(params.couponMarginWarningQuantity);


      // params.getTimeLimitTimeList = (params.getTimeLimitTimeList || []).map((item: any) => {
      // 	return { startTime: formatTime(item.duration[0]), endTime: formatTime(item.duration[1]) };
      // });
      // params.effectiveTimeLimitTimeList = (params.effectiveTimeLimitTimeList || []).map((item: any) => {
      // 	return { startTime: formatTime(item.duration[0]), endTime: formatTime(item.duration[1]) };
      // });
      params.couponDescClause = params.couponDescClause.replace(/(\r|\n)/g, '<br>');

      if (params.couponGetTimeLimitSwitch == 1 && !params.getTimeLimitWeekList.length) {
        return { error: { msg: '请选择可领取时段(星期)!' } };
      }
      if (params.couponGetTimeLimitSwitch == 1 && !params.getTimeLimitTimeList.length) {
        return { error: { msg: '请选择可领取时段(时间段)!' } };
      }
      if (params.couponEffectiveTimeLimitSwitch == 1 && !params.effectiveTimeLimitWeekList.length) {
        return { error: { msg: '请选择可核销时段(星期)!' } };
      }
      if (params.couponEffectiveTimeLimitSwitch == 1 && !params.effectiveTimeLimitTimeList.length) {
        return { error: { msg: '请选择可核销时段(时间段)!' } };
      }

      const { error, success }: any = await router.app.$request('COUPON_ADD', params);
      // success && router.app.$alert(success.msg);
      // error && router.app.$alert(error.msg);
      return { error, success };
    },
    async getCouponList({ commit }: any, params: any) {
      commit('setCouponList', { list: [], total: 0 });
      const { error, success }: any = await router.app.$request('COUPON_LIST', params);
      if (success) {
        success.data.list = (success.data.list || []).map((item: any) => {
          item.couponGetDate = [router.app.$format(item.couponGetStartTime).replace(/-/g, '.'), router.app.$format(item.couponGetEndTime).replace(/-/g, '.')].join('-');
          item.couponEffectiveDateFmt = [
            [
              router.app.$format(item.couponEffectiveStartTime),
              router.app.$format(item.couponEffectiveEndTime),
            ].join('至'),
            item.couponActivedLimitedStartDay == 0 && item.couponActivedLimitedDays == 1
              ? '仅当天有效'
              : (item.couponActivedLimitedStartDay == 0
                ? '领取后当天开始(含当天)有效'
                : '领取后' +
                (item.couponActivedLimitedStartDay + 1 > 0
                  ? '第' + (item.couponActivedLimitedStartDay + 1) + '天开始(含当天)有效'
                  : '当天开始有效')) +
              ', 有效期' +
              item.couponActivedLimitedDays +
              '天',
            [
              router.app.$format(item.couponGetStartTime),
              router.app.$format(item.couponGetEndTime),
            ].join('至'),
          ][item.couponEffectiveSwitch];
          return item;
        });
        commit('setCouponList', success.data);
      }
      return { error, success };
    },
    async getCouponNewList({ commit }: any, params: any) {
      commit('setCouponList', { list: [], total: 0 });
      const { error, success }: any = await router.app.$request('COUPON_NEW_LIST', params);
      if (success) {
        success.data.list = (success.data.list || []).map((item: any) => {
          item.couponGetDate = [router.app.$format(item.couponGetStartTime).replace(/-/g, '.'), router.app.$format(item.couponGetEndTime).replace(/-/g, '.')].join('-');
          item.couponEffectiveDateFmt = [
            [
              router.app.$format(item.couponEffectiveStartTime),
              router.app.$format(item.couponEffectiveEndTime),
            ].join('至'),
            item.couponActivedLimitedStartDay == 0 && item.couponActivedLimitedDays == 1
              ? '仅当天有效'
              : (item.couponActivedLimitedStartDay == 0
                ? '领取后当天开始(含当天)有效'
                : '领取后' +
                (item.couponActivedLimitedStartDay + 1 > 0
                  ? '第' + (item.couponActivedLimitedStartDay + 1) + '天开始(含当天)有效'
                  : '当天开始有效')) +
              ', 有效期' +
              item.couponActivedLimitedDays +
              '天',
            [
              router.app.$format(item.couponGetStartTime),
              router.app.$format(item.couponGetEndTime),
            ].join('至'),
          ][item.couponEffectiveSwitch];
          return item;
        });
        commit('setCouponList', success.data);
      }
      return { error, success };
    },
    async getCouponAnalysis({ commit }: any, params: any) {
      params.couponBusinessEntityId = router.app.$global.tenantId;
      const { error, success }: any = await router.app.$request('COUPON_ANALYSIS', params);
      success && commit('setCouponAnalysis', success.data);
      return { error, success };
    },
    async getCouponInfo({ commit, state }: any) {
      const { error, success }: any = await router.app.$request('COUPON_INFO', { couponId: state.infoId });
      success && commit('setCouponInfo', success.data);
      return { error, success };
    },
    async getCouponExternalCode({ commit, state }: any, params: any) {
      params.couponId = state.infoId;
      const { error, success }: any = await router.app.$request('COUPON_INFO_EXTERNAL_CODE', params);
      success && commit('setCouponExternalCode', success.data);
      return { error, success };
    },
    async launchCoupon({ commit }: any, params: any) {
      const { error, success }: any = await router.app.$request('COUPON_LAUNCH', params);
      return { error, success };
    },
    async launchCouponBatch({ commit }: any, params: any) {
      const { error, success }: any = await router.app.$request('COUPON_LAUNCH_BATCH', params);
      return { error, success };
    },
    async discardCoupon({ commit, state }: any) {
      const { error, success }: any = await router.app.$request('COUPON_DISCARD', { couponId: state.infoId });
      return { error, success };
    },
    async offCoupon({ commit, getters, state }: any) {
      const { error, success }: any = await router.app.$request('COUPON_ENABLE', {
        couponId: state.infoId,
        couponStatus: getters.STATUS_VALUE.STOPPED,
      });
      return { error, success };
    },
    async onCoupon({ commit, getters, state }: any) {
      const { error, success }: any = await router.app.$request('COUPON_ENABLE', {
        couponId: state.infoId,
        couponStatus: getters.STATUS_VALUE.LAUNCHED,
      });
      return { error, success };
    },
    async getActivityList({ commit, state, dispatch, rootState }: any, params: any) {
      const { error, success }: any = await router.app.$request('COUPON_ACTIVITYLIST', params);
      if (success) {
        success.data.list = (success.data.list || []).map((item: any) => {
          item.activityDateFmt = [
            router.app.$format(item.activityStartDate) + ' 至 2099-12-31',
            router.app.$format(item.activityStartDate) +
            ' 至 ' +
            router.app.$format(item.activityEndDate),
          ][Number(item.activityType)];
          return item;
        });
        commit('setActivityList', success.data);
      }
      return { error, success };
    },
    async getBusinessEntityGroupList({ commit, state }: any, params: any) {
      params.writeOffBusinessEntityId = router.app.$global.tenantId;
      params.accountToken = router.app.$global.token;
      params.workflowStatusId = 5; // 选择启用状态
      let { error, success }: any = await router.app.$request('BUSINWSSENTITYGROUP', params);
      if (success) {
        commit('businessEntityGroupList', success.data.list);
      }
      return { error, success };
    },
    // async Upload({ commit, state }: any, params: any) {
    // 	const { error, success }: any = await router.app.$request('FILE_UPLOAD', params);
    // 	return { error, success };
    // },
    async auditRejectAndPass({ commit, state }: any, params: any) {
      params.writeOffBusinessEntityId = router.app.$global.tenantId;
      params.accountToken = router.app.$global.token;
      let { error, success }: any = await router.app.$request('AUDITREJECTANDPASS', params);
      return { error, success };
    },
    async getCouponEntityList({ commit, state }: any, params: any) {
      commit('setCouponList', { list: [], total: 0 });
      params.couponId = state.infoId;
      params.couponInstanceBusinessEntityId = router.app.$global.tenantId;
      const { error, success }: any = await router.app.$request('COUPON_ENTITY_LIST', params);
      if (success) {
        commit('setCouponList', success.data);
      }
      return { error, success };
    },
    async getCouponCancelList({ commit, state }: any, params: any) {
      // commit('setCouponCancelPageLoading', true);
      const status = params.status;
      delete params.status;
      params.couponId = state.infoId;
      params.couponInstanceBusinessEntityId = router.app.$global.tenantId;
      const { error, success }: any = await router.app.$request('COUPON_ENTITY_LIST', params);
      // if (success) {
      //   // commit('setCouponCancelList', { ...success.data, status });
      //   // commit('setCouponCancelPageLoading', false);
      // }
      return { error, success };
    },
    async getCouponCancelListActive({ commit }: any, params: any) {
      commit('setCouponCancelListActive', params);
    },
    async getCouponPutinList({ commit }: any, params: any) {
      commit('setCouponCancelPageLoading', true);
      const status = params.status;
      delete params.status;
      params.couponBusinessEntityId = router.app.$global.tenantId;
      const { error, success }: any = await router.app.$request('COUPON_LIST', params);
      if (success) {
        commit('setCouponCancelList', { ...success.data, status });
        commit('setCouponCancelPageLoading', false);
      }
      return { error, success };
    },
    async effectiveCouponEntity({ commit, state }: any) {
      let params: any = {
        couponInstanceQrCode: state.effectiveQrCode,
        couponInstanceFlowWriteoffChannel: 'ma6',
        operationType: state.effectiveSessionId ? 1 : 0,
        writeSessionId: state.effectiveSessionId,
        writeOffBusinessEntityId: router.app.$global.tenantId,
        accountToken: router.app.$global.token,
      };
      let { error, success }: any = await router.app.$request('COUPON_EFFECTIVE', params);
      if (success && success.data && success.data.writeSessionId) {
        commit('setEffectiveSessionId', success.data.writeSessionId);
      }
      if (error) {
        router.app.$dialog({ message: error.msg })
      }
      return { error, success };
    },
    async getEffectiveCouponEntity({ commit, state }: any, operationType: any = 0) {
      let params: any = {
        couponInstanceQrCode: state.effectiveQrCode,
        couponInstanceFlowWriteoffChannel: '商户通',
        operationType,
        // operationType: state.effectiveSessionId ? 1 : 0,
        writeSessionId: state.effectiveSessionId,
        writeOffBusinessEntityId: router.app.$global.tenantId,
        writeOffAccountId: operationType == 1 ? router.app.$global.uId : "",
        accountToken: router.app.$global.token,
        writeOffAccountName: router.app.$global.uName,
        flowType: 1
      };
      let { error, success }: any = await router.app.$request('COUPON_EFFECTIVE', params);
      if (success && success.data && success.data.writeSessionId) {
        const _item = success.data.coupon;
        _item.couponCategoryName = couponCategoryObj[_item.couponCategoryId + ''];
        _item.couponInstanceWriteOffTime = router.app.$format(_item.couponInstanceWriteOffTime);
        _item.couponInstanceGetTime = router.app.$format(_item.couponInstanceGetTime);
        _item.couponEffectiveStartTime = router.app.$format(_item.couponEffectiveStartTime, "YYYY.MM.DD");
        _item.couponEffectiveEndTime = router.app.$format(_item.couponEffectiveEndTime, "YYYY.MM.DD");
        _item.couponEffectiveConditionPrice = [
          '不限金额',
          '消费满' +
          (router.app as any).$currency(Number(_item.couponEffectiveConditionPrice).d(100)) +
          '元, 可使用此券',
        ][_item.couponEffectiveConditionSwitch];
        _item.writeOffTime && (_item.writeOffTime = router.app.$format(_item.writeOffTime));
        _item.effectiveTimeLimitWeekStr = _item.couponEffectiveTimeLimitSwitch == 0
          ? '不限星期'
          : (_item.effectiveTimeLimitWeekList || [])
            .map((item: number) => {
              return ['周一', '周二', '周三', '周四', '周五', '周六', '周日'][item - 1];
            })
            .join(';');
        _item.effectiveTimeLimitTimeStr =
          _item.couponEffectiveTimeLimitSwitch == 0
            ? '不限时段'
            : (_item.effectiveTimeLimitTimeList || [])
              .map((item: any) => item.startTime + '-' + item.endTime)
              .join(';');
        _item.imgurl = _item.photoUriList ? _item.photoUriList[0] : 'COUPON_NO_PIC_URL';
        success.data.coupon = _item;
        commit('setEffectiveCouponEntity', success.data);
        commit('setEffectiveSessionId', success.data.writeSessionId);
      }
      if (error) {
        console.log(error);
      }
      return { error, success };
    },
  },
};